// Generated by LiveScript 1.6.0
var watch, unwatch, callWatchers;
watch = function(ctx, key, fn){
  var list;
  list = ctx.watchers.get(key) || [];
  list.push(fn);
  return ctx.watchers.set(key, list);
};
unwatch = function(ctx, key, fn){
  var list, remaining, i$, to$, i;
  switch (false) {
  case key != null:
    return ctx.watchers.clear();
  case fn != null:
    return ctx.watchers['delete'](key);
  default:
    if (list = ctx.watchers.get(key)) {
      remaining = [];
      for (i$ = 0, to$ = list.length; i$ < to$; ++i$) {
        i = i$;
        if (list[i] !== fn) {
          remaining.push(list[i]);
        }
      }
      if (remaining.length > 0) {
        return ctx.watchers.set(key, remaining);
      } else {
        return ctx.watchers['delete'](key);
      }
    }
  }
};
callWatchers = function(ctx, changedKey, value, getValue){
  var exact, i$, to$, i;
  exact = ctx.watchers.get(changedKey);
  if (exact != null) {
    for (i$ = 0, to$ = exact.length; i$ < to$; ++i$) {
      i = i$;
      exact[i](value);
    }
  }
  return ctx.watchers.forEach(function(fns, watched){
    var val, i$, to$, i, results$ = [];
    if (watched !== changedKey && changedKey.startsWith(watched + ".")) {
      val = getValue(watched);
      for (i$ = 0, to$ = fns.length; i$ < to$; ++i$) {
        i = i$;
        results$.push(fns[i](val));
      }
      return results$;
    }
  });
};
module.exports = {
  watch: watch,
  unwatch: unwatch,
  callWatchers: callWatchers
};